export const cloudinaryConfig = {
    cloud_name: 'dcavq4nkl',
    api_key: '521993184566758',
    api_secret: 'i0P8iHZ6Gg-VZpkBz6k3QVFidAA',
    api_environment_variable: 'CLOUDINARY_URL=cloudinary://521993184566758:i0P8iHZ6Gg-VZpkBz6k3QVFidAA@dcavq4nkl',
    upload_preset: 'movinity_images',
};